import { render, staticRenderFns } from "./layouts.empty.8d436c0c.vue?vue&type=template&id=0bc5ad79"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports